import { ArrowRight, CalendarDays, ClipboardCheck, MapPinned } from "lucide-react";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/ui";
import { useAuth } from "../App";

export function HomePage() {
  const { principal } = useAuth();
  const today = new Intl.DateTimeFormat("es-MX", { timeZone: "America/Tijuana", weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(new Date());
  return <>
    <PageHeader eyebrow="Administración UBP" title={`Buen día, ${principal?.displayName}`} description={`Jornada operativa · ${today}`} />
    <section className="orientation-card">
      <div><p className="eyebrow">Propósito del sistema</p><h2>Una jornada clara, sin imponer una ruta.</h2><p>Configure lo que debe atenderse en cada zona. El personal conserva autonomía para organizar el recorrido.</p></div>
      <div className="orientation-code" aria-hidden><span>PA</span><span>PB</span><span>EX</span></div>
    </section>
    <section className="section-block"><div className="section-heading"><h2>Acciones principales</h2><p>Configuración y consulta operativa.</p></div>
      <div className="action-grid">
        <Link to="/zonas" className="action-card"><MapPinned /><div><strong>Administrar zonas</strong><span>Datos de área y códigos QR</span></div><ArrowRight /></Link>
        <Link to="/tareas" className="action-card"><ClipboardCheck /><div><strong>Configurar tareas</strong><span>Actividades y frecuencias</span></div><ArrowRight /></Link>
        <Link to="/calendario" className="action-card"><CalendarDays /><div><strong>Definir cierres</strong><span>Festivos y fechas no disponibles</span></div><ArrowRight /></Link>
        <Link to="/reporte" className="action-card"><ClipboardCheck /><div><strong>Consultar reporte</strong><span>Tareas, estados e historial</span></div><ArrowRight /></Link>
      </div>
    </section>
  </>;
}
